/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const broken_chain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.667 3.867 3.8 2m.933 3.733H3.8m3.733-2.8V2M9.4 4.8h2.8c1.525 0 2.8 1.275 2.8 2.8s-1.275 2.8-2.8 2.8H9.4M3 8.174l-1.18 1.18c-1.078 1.078-1.078 2.88 0 3.96 1.078 1.078 2.882 1.078 3.96 0L7.093 12"
    />
  </svg>
)
export default broken_chain
